import { Calendar, CalendarDays } from 'lucide-react'
import type { ModuleDefinition } from '../types'
import { eventRow } from '../layouts/rows'
import { lazyPage } from '@/lib/lazyPage'

const EventsPage = lazyPage(() => import('@/pages/Events'), 'EventsPage')
const EventDetailsPage = lazyPage(() => import('@/pages/EventDetails'), 'EventDetailsPage')

export const eventsModule: ModuleDefinition = {
  menuCounters: true,
  key: 'events',
  icon: Calendar,
  iconName: 'calendar',
  namespaces: ['events'],
  ready: true,
  /* F-198: the default is what the page always drew. */
  layouts: { fallback: 'cards', renders: ['cards', 'list', 'compact', 'calendar'], toRow: eventRow },
  ListPage: EventsPage,
  renderDetail: () => <EventDetailsPage />,
  workflow: { trigger: { block: 'events', icon: CalendarDays, families: ['event'] } }
}
